import { useEffect, useState } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { OrgLessHome } from "@/features/onboarding/components/OrgLessHome";

type HomeRouteContext = {
  organizations?: unknown[] | null;
  savedOrgBusinessUnit?: { id?: string };
};

export const Route = createFileRoute("/_org/org/home/")({
  validateSearch: z.object({
    sharedBy: z.string().uuid().optional().catch(undefined),
  }),
  beforeLoad: ({ context, search }) => {
    const { organizations, savedOrgBusinessUnit } = context as HomeRouteContext;
    const organizationBusinessUnitId = savedOrgBusinessUnit?.id;

    if (organizationBusinessUnitId) {
      if (search.sharedBy) {
        throw redirect({
          to: "/org/bu/$organizationBusinessUnitId/provider-profile/$userId",
          params: {
            organizationBusinessUnitId,
            userId: search.sharedBy,
          },
        });
      }
      throw redirect({
        to: "/org/bu/$organizationBusinessUnitId/home",
        params: { organizationBusinessUnitId },
      });
    }

    if (!organizations || organizations.length > 0) {
      throw redirect({ to: "/org/providers" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { sharedBy } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [capturedSharedBy] = useState(() => sharedBy);

  useEffect(() => {
    if (sharedBy) {
      navigate({ to: ".", search: {}, replace: true });
    }
  }, [sharedBy, navigate]);

  return <OrgLessHome sharedBy={capturedSharedBy} />;
}
